import SlotsBetHistoryApi from './SlotsBetHistoryApi';
export default SlotsBetHistoryApi;